import styled from 'styled-components';
import { TableContainer } from 'cdk-radial';

const StyledTableContainer = styled(TableContainer)`
    
`;

export default StyledTableContainer;
